import React from "react";
import { ProductItemComponentProps } from "../../constants/interface.ts";
import { useTranslation } from "react-i18next";
import IconCardComponent from "../IconCardComponent/IconCardComponent.tsx";

const WhyChooseProductComponent = (props: ProductItemComponentProps) => {
    const { title = '', paragraph = '', list = [] } = props;
    const {t} = useTranslation();

    return (
        <div className="flex flex-col gap-8 lg:gap-16">
            <div className="flex flex-col gap-5">
                <p className="text-3xl font-semibold text-black-1A1 lg:text-4xl">{t(title)}</p>
                <>
                {
                    (paragraph) &&
                    <p className="text-base font-normal text-gray-535 lg:text-xl lg:max-w-[40rem]">{t(paragraph)}</p>
                }
                </>
            </div>
            <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                {
                    list?.map((item, index: number) => (
                        <React.Fragment key={index}>
                            <IconCardComponent
                                img={item.img || ''}
                                imgContainerClass={'bg-blue-1F3 text-white'}
                                title={item.title || ''}
                                titleClass={'text-black-1A1'}
                                paragraph={item.paragraph || ''}
                                paragraphClass={'text-gray-535'}
                                index={index}
                            />
                        </React.Fragment>
                    ))
                }
            </div>
        </div>
    );
};

export default  WhyChooseProductComponent;